import { z } from "zod";

export const getProjectTicketsParamsSchema = z.object({
	projectId: z.string().nonempty(),
});

export const getProjectTicketsQuerySchema = z
	.object({
		state: z
			.preprocess(
				// A query string carries one `state` as a string and several as an array, so a
				// single-state filter would fail an `z.array` that had not been told the difference.
				(val) => (val === undefined ? undefined : Array.isArray(val) ? val : [val]),
				z.array(z.enum(["active", "inactive", "archived"])).optional(),
			)
			.optional(),
	})
	.optional();
